import angular from 'angular';
//This filter gets a number of minutes and formats it to 'hh:mm' format.
angular.module('commonServices').filter('vatRateType', [
  'translateListFilter',
  'percentageFilter',
  function(translateListFilter, percentageFilter) {
    return function(vatRate, vatType, decimals = 0) {
      if (vatType === 0) return percentageFilter(vatRate, decimals);
      return translateListFilter(vatType, 'vatType', '');
    };
  },
]);
